export const FEATURE_TYPE = {
    MASSAGE_V1 : "MASSAGE_V1",
    MASSAGE_FACE : "MASSAGE_FACE"
};

export const hasMedicalEducation = (feature) => {
    return feature?.hasMedicalEducation;
}
